export default "__VITE_PUBLIC_ASSET__4a08b114__"